import type * as Style from '../../index.js'
import { Keyword, Length, LengthOrPosition, NullLength, pickFirst } from '../../values/index.js'
import * as inflection from 'inflection'

export enum Fit {
  'cover' = 'cover',
  'contain' = 'contain',
  'fill' = 'fill',
  'none' = 'none'
}

export const Props = (props: any = {}) => ({
  width: [NullLength(props.width), Length(props.width)].reduce(pickFirst),
  height: [NullLength(props.height), Length(props.height)].reduce(pickFirst),
  objectFit: Keyword<Fit>(props.objectFit, Fit),
  objectPositionX: LengthOrPosition(props.objectPositionX),
  objectPositionY: LengthOrPosition(props.objectPositionY)
})
export type Props = ReturnType<typeof Props>
export const validate = () => true
export const fix = (props: Props, styles: Style.Rule[]) => props
export const label = 'Media sizing'
export const type = 'media'
export const property = 'mediaIds'
export const category = 'aspect'
export const summarize = (props: Props, styles?: Style.Rule[], formId?: string) => props.objectFit
